import type { Msg } from '@halo/chat-sdk-react';
import { MessageBubble, type MessageBubbleProps } from '@halo/ui-chat-react';
import { ColorConverter } from '@halo/utils';
import { useIsMe, useUserInfo } from '@/scripts/hooks';

export interface MsgBubbleProps extends MessageBubbleProps {
  message: Msg;
}

export const MsgBubble = memo(function MsgBubble({ message, ...props }: MsgBubbleProps) {
  const { user } = useUserInfo(message.owner_id);
  const isMe = useIsMe(user?.user_id);

  const bubbleProps = useMemo(() => {
    if (isMe) {
      return {
        bg: ColorConverter.getRgb(
          ColorConverter.blendedRGB(user?.avatar_color || '#703EFF', 0.1)
        ),
      };
    }
  }, [isMe, user]);

  return <MessageBubble {...bubbleProps} {...props} />;
});
